import Glide from '@glidejs/glide'

import '@glidejs/glide/dist/css/glide.core.min.css'
import '@glidejs/glide/dist/css/glide.theme.min.css'

import onVisible from './on-visible.js'

if (!document.querySelector('#carousel-team')) {
  return
}

const glide = new Glide('#carousel-team', {
  type: 'carousel',
  focusAt: 'center',
  perView: 4.5,
  gap: 0,
  breakpoints: {
    1024: {
      perView: 2.5,
    },
    640: {
      perView: 1.4,
    },
  },
})

let is_muted = true

function setupBtnMuteClass(btnMute) {
  if (is_muted) {
    btnMute.classList.add('bg-volume-mute')
    btnMute.classList.remove('bg-volume')
  } else {
    btnMute.classList.add('bg-volume')
    btnMute.classList.remove('bg-volume-mute')
  }
}

function setupBtnMuteClick(video, btnMute) {
  btnMute.addEventListener('click', () => {
    video.muted = !video.muted
    is_muted = video.muted
    setupBtnMuteClass(btnMute)
  })
}

glide.on(['mount.after', 'run.after'], () => {
  const video = document.querySelector(
    '#carousel-team .glide__slide--active video'
  )
  const mute = document.querySelector(
    '#carousel-team .glide__slide--active .glide__mute'
  )
  const product = document.querySelector(
    '#carousel-team .glide__slide--active .glide__product'
  )

  onVisible(document.querySelector('#team-soul-shine'), () => {
    setTimeout(() => video.play(), 500)
  })

  video.muted = is_muted
  mute.classList.remove('opacity-0')

  if (product) {
    product.classList.remove('opacity-0')
  }

  setupBtnMuteClass(mute)
  setupBtnMuteClick(video, mute)
})

// every run
glide.on('run.before', () => {
  const slides = document.querySelectorAll('#carousel-team .glide__slide')

  slides.forEach((slide) => {
    const video = slide.querySelector('video')
    const mute = slide.querySelector('.glide__mute')
    const product = slide.querySelector('.glide__product')

    video.load()
    mute.classList.add('opacity-0')

    if (product) {
      product.classList.add('opacity-0')
    }
  })
})

glide.mount()
